import BaseDTO from '../base/BaseDTO';

export default class SampleCategory extends BaseDTO {

    public name: string;
    public defaultWeight: number | null;
    public tariffCode: string | null;
    public sampleTypeId: number;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.name = data['name'];
        this.defaultWeight = data['defaultWeight'] || null;
        this.tariffCode = data['tariffCode'] || null;
        this.sampleTypeId = data['sampleTypeId'];
    }
}